module.exports = __webpack_public_path__ + "static/media/ni.5bafbb9f.svg";